import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { deleteQuery, fetchQuestions } from "../../actions/ai-action";
import moment from "moment";
import { toast } from "react-toastify";

// Bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

const SavedQueriesModal = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const questions = useSelector((state) => state.data.aiQuestions) || [];
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    if (show) {
      dispatch(fetchQuestions("", 100, 1));
    }
  }, [show, dispatch]);

  const handleDelete = (e, id) => {
    e.stopPropagation();
    if (window.confirm("Are you sure you want to delete this query?")) {
      dispatch(deleteQuery(id))
        .then(() => {
          toast.success("Query deleted");
          dispatch(fetchQuestions("", 100, 1));
        })
        .catch(() => toast.error("Failed to delete query"));
    }
  };

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const copyToClipboard = (e, text) => {
    e.stopPropagation();
    navigator.clipboard.writeText(text);
    toast.success("Copied to clipboard");
  };

  const filteredQuestions = questions.filter(
    (q) =>
      q.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (q.answer && q.answer.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  return (
    <Modal
      isOpen={show}
      onRequestClose={onHide}
      contentLabel="Saved Queries"
      className="ai-modal-content"
      overlayClassName="ai-modal-overlay"
    >
      <div className="ai-modal-header d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center gap-3">
            <div className="modal-icon-wrapper">
                <img src="/images/AI/saved.svg" alt="Saved" width="24" />
            </div>
            <div>
                <h5 className="fw-bold mb-0">Saved Queries</h5>
                <div className="text-muted small">Your bookmarked AI responses</div>
            </div>
        </div>
        <button className="btn-close-custom" onClick={onHide}>✕</button>
      </div>

      <div className="ai-modal-body">
        {/* Search */}
        <div className="ai-modal-search mb-4">
            <img src="/images/icon-search.svg" alt="search" className="search-icon" width="16" />
            <input 
                type="text" 
                placeholder="Search your saved queries..." 
                className="form-control ps-5 rounded-3"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
        </div>

        {/* List */}
        <div className="saved-queries-list hide-scrollbar">
            {filteredQuestions.length === 0 ? (
                <div className="text-center text-muted py-5">
                    No saved queries found.
                </div>
            ) : (
                filteredQuestions.map((q) => (
                    <div key={q.id} className="saved-query-card mb-3 p-3 border rounded-3 bg-white">
                        <div className="d-flex justify-content-between align-items-start mb-1">
                            <h6 className="fw-bold mb-1 flex-grow-1 pe-3">{q.question}</h6>
                            <div className="d-flex gap-2 flex-shrink-0">
                                <button className="btn-icon-tiny" title="Copy" onClick={(e) => copyToClipboard(e, q.question + '\n\n' + q.answer)}>
                                    <img src="/images/AI/copy.svg" alt="copy" width="18" />
                                </button>
                                <button className="btn-icon-tiny" title="Delete" onClick={(e) => handleDelete(e, q.id)}>
                                    <img src="/images/AI/trash.svg" alt="delete" width="18" />
                                </button>
                            </div>
                        </div>
                        <div className="text-muted small mb-3">{moment(q.created_at).format("MMM D, YYYY")}</div>
                        
                        <div className={`saved-query-answer text-muted small ${expandedId === q.id ? 'expanded' : 'collapsed'}`}>
                            <div dangerouslySetInnerHTML={{ __html: q.answer }} />
                        </div>
                        
                        <button className="btn-read-more" onClick={() => toggleExpand(q.id)}>
                            {expandedId === q.id ? 'Show less' : 'Read more'} 
                            <img src="/images/arrow-down.svg" alt="" width="10" style={{ transform: expandedId === q.id ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s', marginLeft: 4 }} />
                        </button>
                    </div>
                ))
            )}
        </div>
        
        <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
             <div className="text-muted small">{filteredQuestions.length} saved queries</div>
             <div className="d-flex gap-2">
                 <button className="btn btn-light btn-sm fw-medium px-3" disabled>Clear All</button>
                 <button className="btn btn-primary btn-sm fw-medium px-4" onClick={onHide}>Done</button>
             </div>
        </div>
      </div>
    </Modal>
  );
};

export default SavedQueriesModal;
